import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Slide from '@mui/material/Slide'
import { useParams, useHistory } from 'react-router-dom'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import Button from '@mui/material/Button'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import CheckIcon from '@mui/icons-material/Check'
import { toast } from 'react-toastify'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import { UrlParams } from '../../types'
import YellowSwitch from '../../common/YellowSwitch'
import DashboardLayout from '../layouts/DashboardLayout'
import ColorButton from '../../common/ColorButton'
import getFirestoreDocById from '../../common/getFirestoreDocById'
import { doc, updateDoc, db } from '../../config/firebaseConfig'
import useAuth from '../../hooks/useAuth'
import color1ConsoleLog from '../../common/color1ConsoleLog'
import FullPageLoader from '../../common/FullPageLoader'

const ReviseStep8 = () => {
  console.log('ReviseStep8')

  const { user } = useAuth()
  console.log('%cuser : %s', color1ConsoleLog, user?.uid)

  const { id, area } = useParams<UrlParams>()
  console.log('%cThe id is : %s', color1ConsoleLog, id)
  console.log('%cThe area is : %s', color1ConsoleLog, area)

  const history = useHistory()

  const goToReviseStep7 = () => {
    history.push(`/revision/${area}/7/${id}`)
  }

  const goToReviseStep9 = () => {
    history.push(`/revision/${area}/9/${id}`)
  }

  const [formData, setFormData]: any = useState()
  const [loading, setLoading] = useState(true)
  const [isAllowed, setIsAllowed] = useState(false)
  const [key, setKey] = useState('')
  // eslint-disable-next-line
  const [areaUrlParam, setAreaUrlParam] = useState('')
  const [approvedAt, setApprovedAt] = useState('')

  useEffect(() => {
    (async () => {
      if (id) {
        const res = await getFirestoreDocById(id)
        if (res) {
          setFormData(res)
          if (area === 'tsu') {
            console.log('res?.p16workSupervisor', res?.p16workSupervisor)
            console.log('%cp16workSupervisor has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16workSupervisorApproved8')
            setAreaUrlParam('tsu')
            setApprovedAt('p16workSupervisorApprovedAt8')
          }
          if (area === 'pep') {
            console.log('%cp16pepCoordinator has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16pepCoordinatorApproved8')
            setAreaUrlParam('pep')
            setApprovedAt('p16pepCoordinatorApprovedAt8')
          }
          if (area === 'aco') {
            console.log('%cp16areaCoordinator has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16areaCoordinatorApproved8')
            setAreaUrlParam('aco')
            setApprovedAt('p16areaCoordinatorApprovedAt8')
          }
          if (area === 'qt') {
            console.log('%cp16quality has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16qualityApproved8')
            setAreaUrlParam('qt')
            setApprovedAt('p16qualityApprovedAt8')
          }
          if (area === 'ta') {
            console.log('%cp16technicalArea has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16technicalAreaApproved8')
            setAreaUrlParam('ta')
            setApprovedAt('p16technicalAreaApprovedAt8')
          }
          if (area === 'ps') {
            console.log('%cp16patrimonialSecurity has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16patrimonialSecurityApproved8')
            setAreaUrlParam('ps')
            setApprovedAt('p16patrimonialSecurityApprovedAt8')
          }
          if (area === 'ep') {
            console.log('%cp16externalPrevencionist has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16externalPrevencionistApproved8')
            setAreaUrlParam('ep')
            setApprovedAt('p16externalPrevencionistApprovedAt8')
          }
          if (area === 'sass') {
            console.log('%cp16sass has id', color1ConsoleLog)
            setIsAllowed(true)
            setKey('p16sassApproved8')
            setAreaUrlParam('sass')
            setApprovedAt('p16sassApprovedAt8')
          }
          setLoading(false)
        } else {
          setLoading(false)
        }
      }
    })()
  }, [])

  if (loading) {
    <Typography>Cargando</Typography>
  }
  console.log(formData)

  const approve = async (e: any) => {
    e.preventDefault()
    const approveformRef = doc(db, 'forms', id)
    const obj: any = {}
    obj[key] = true
    obj[approvedAt] = new Date()
    try {
      await updateDoc(approveformRef, obj)
      console.log('approved', key, approvedAt)
      toast.success('La aprobación se actualizó correctamente')
    } catch (updateError) {
      toast.error(`Error: ${updateError}`)
    }
  }

  const disapprove = async (e: any) => {
    e.preventDefault()
    const approveformRef = doc(db, 'forms', id)
    const obj: any = {}
    obj[key] = false
    obj[approvedAt] = new Date()
    try {
      await updateDoc(approveformRef, obj)
      console.log('disapproved', key, approvedAt)
      toast.success('La desaprobación se actualizó correctamente')
    } catch (updateError) {
      toast.error(`Error: ${updateError}`)
    }
  }

  return (
    <DashboardLayout>
      {loading ? <FullPageLoader /> : (
        <Slide direction="right" in mountOnEnter unmountOnExit>
          <Grid sx={{ mt: 4 }} container justifyContent="center" spacing={2}>
            <Grid item xs={10} sm={9} md={5} lg={7}>
              {
                (formData?.p16workSupervisor === user?.uid)
                  || (formData?.p16pepCoordinator === user?.uid)
                  || (formData?.p16areaCoordinator === user?.uid)
                  || (formData?.p16quality === user?.uid)
                  || (formData?.p16technicalArea === user?.uid)
                  || (formData?.p16patrimonialSecurity === user?.uid)
                  || (formData?.p16externalPrevencionist === user?.uid)
                  || (formData?.p16sass === user?.uid)
                  || (formData?.p16sassAllowedList?.includes(user?.uid))
                  ? (
                    <>
                      <Typography
                        sx={{ mb: 2 }}
                        align="center"
                        variant="h6"
                        color="text.secondary"
                        gutterBottom
                      >
                        ASEOS
                      </Typography>

                      <Grid display="flex" justifyContent="center" item xs={12}>
                        <FormControlLabel
                          control={(
                            <YellowSwitch
                              checked={formData?.p8Show}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          )}
                          label={formData?.p8Show ? 'Esta página aplica' : 'Esta página no aplica'}
                        />
                      </Grid>
                      <Box
                        component="div"
                        sx={{
                          display: formData?.p8Show ? 'block' : 'none',
                        }}
                      >
                        <Box sx={{
                          display: 'flex', justifyContent: 'center', mt: 4, mb: 2,
                        }}
                        >
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Envases químicos rotulados</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="atrapamiento"
                              name="atrapamiento"
                              value={formData?.p8chemEnvase}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8chemEnvase === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8chemEnvase === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8chemEnvase === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Cuenta con HDS</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="aplastamiento"
                              name="aplastamiento"
                              value={formData?.p8hasHds}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8hasHds === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8hasHds === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8hasHds === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>

                        </Box>

                        {(formData?.p8hasHdsImage?.length > 1 && formData?.p8hasHdsImage !== 'none')
                          && (
                            <Card sx={{ maxWidth: 345, mt: 2, mb: 4 }}>
                              <CardMedia
                                component="img"
                                height="140"
                                image={
                                  formData?.p8hasHdsImage
                                  && formData?.p8hasHdsImage
                                }
                                alt="cuenta con HDS"
                              />
                              <CardContent>
                                <Typography gutterBottom variant="subtitle1" component="div">
                                  Cuenta con HDS
                                </Typography>
                              </CardContent>
                            </Card>
                          )}

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">indicar  SUSPEL</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="golpeadorpor"
                              name="golpeadorpor"
                              value={formData?.p8indicateSuspel}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8indicateSuspel === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8indicateSuspel === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8indicateSuspel === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">Guantes Showa</FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="golpeadocon"
                              name="golpeadocon"
                              value={formData?.p8showaGlove}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8showaGlove === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8showaGlove === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8showaGlove === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Careta Facial
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="caida"
                              name="caida"
                              value={formData?.p8faceShield}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8faceShield === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8faceShield === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8faceShield === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Traje Antiácido
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="contactoconobjetoscortantes"
                              name="contactoconobjetoscortantes"
                              value={formData?.p8antSuit}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8antSuit === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8antSuit === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8antSuit === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Bota de goma
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="contactoconobjetoscalientes"
                              name="contactoconobjetoscalientes"
                              value={formData?.p8rubberBoot}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8rubberBoot === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8rubberBoot === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8rubberBoot === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 2 }} component="fieldset">
                            <FormLabel component="legend">
                              Kit Antiderrame
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="proyecciondeparticulas"
                              name="proyecciondeparticulas"
                              value={formData?.p8antSpillKit}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8antSpillKit === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8antSpillKit === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8antSpillKit === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                          <FormControl sx={{ display: 'flex', mb: 10 }} component="fieldset">
                            <FormLabel component="legend">
                              Extensiones eléctricas chequeadas
                            </FormLabel>
                            <RadioGroup
                              sx={{ flex: '1', flexDirection: 'row' }}
                              aria-label="proyecciondeparticulas"
                              name="proyecciondeparticulas"
                              value={formData?.p8extensionElectricalCheck}
                            >
                              <FormControlLabel value="SI" control={<Radio checked={formData?.p8extensionElectricalCheck === 'SI'} />} label="SI" />
                              <FormControlLabel value="NO" control={<Radio checked={formData?.p8extensionElectricalCheck === 'NO'} />} label="NO" />
                              <FormControlLabel value="NA" control={<Radio checked={formData?.p8extensionElectricalCheck === 'NA'} />} label="N/A" />
                            </RadioGroup>
                          </FormControl>

                        </Box>

                        {(formData?.p8extensionElectricalCheckImage?.length > 1 && formData?.p8extensionElectricalCheckImage !== 'none')
                          && (
                            <Card sx={{ maxWidth: 345, mt: 2, mb: 4 }}>
                              <CardMedia
                                component="img"
                                height="140"
                                image={
                                  formData?.p8extensionElectricalCheckImage
                                  && formData?.p8extensionElectricalCheckImage
                                }
                                alt="extensiones eléctricas chequeadas"
                              />
                              <CardContent>
                                <Typography gutterBottom variant="subtitle1" component="div">
                                  Extensiones eléctricas chequeadas
                                </Typography>
                              </CardContent>
                            </Card>
                          )}

                      </Box>

                      <Grid
                        display={isAllowed ? 'flex' : 'none'}
                        justifyContent="space-evenly"
                        sx={{ mt: 4 }}
                      >
                        <Button
                          startIcon={<HighlightOffIcon />}
                          sx={{ mb: 10, bgcolor: '#db1414' }}
                          color="error"
                          variant="contained"
                          onClick={(e) => disapprove(e)}
                        >
                          Desaprobar
                        </Button>
                        <Button
                          startIcon={<CheckIcon />}
                          sx={{ mb: 10, bgcolor: '#42b50e' }}
                          color="success"
                          variant="contained"
                          onClick={(e) => approve(e)}
                        >
                          Aprobar
                        </Button>
                      </Grid>

                      <Grid sx={{ mb: 2 }} container justifyContent="space-between">
                        <Grid
                          xs={12}
                          md={5}
                          sx={{ mb: 2 }}
                        >
                          <ColorButton
                            fullWidth
                            startIcon={<ArrowLeftIcon />}
                            onClick={goToReviseStep7}
                          >
                            Ir a la página anterior
                          </ColorButton>
                        </Grid>
                        <Grid
                          xs={12}
                          md={5}
                        >
                          <ColorButton
                            fullWidth
                            endIcon={<ArrowRightIcon />}
                            onClick={goToReviseStep9}
                          >
                            Ir a la página siguiente
                          </ColorButton>
                        </Grid>

                      </Grid>
                    </>
                  )
                  : 'Por favor inicie sesión para visualizar su documento a revisar'
              }

              {user ? (
                <Typography color="green">Usted ha iniciado sesión.</Typography>
              )
                : (
                  <Typography color="red" sx={{ mt: 2 }}>Usted no ha iniciado sesión</Typography>
                )}

            </Grid>
          </Grid>
        </Slide>
      )}

    </DashboardLayout>
  )
}

export default ReviseStep8